/**
 * Ease of Movement (EMV)
 *
 * Relates price change to volume. High values indicate prices moved
 * upward easily on low volume.
 * EMV = ((H+L)/2 − (prevH+prevL)/2) / (Volume / (H−L))
 *
 * Category: Volume | Pane: Separate
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";
import { computeSMA } from "./sma";

export const emvIndicator: IndicatorDefinition = {
  id: "emv",
  name: "Ease of Movement",
  shortName: "EMV",
  category: "volume",
  pane: "separate",
  params: [
    { key: "period", label: "Period", type: "number", default: 14, min: 1, max: 200 },
    { key: "color", label: "Color", type: "color", default: "#607D8B" },
  ],
  plots: [
    { key: "emv", label: "EMV", color: "#607D8B", style: "line", lineWidth: 2, priceScaleId: "emv" },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { period } = params;
    const data: { time: number; value: number }[] = [];

    if (candles.length < 2) return [{ key: "emv", data }];

    const raw: number[] = [0];
    for (let i = 1; i < candles.length; i++) {
      const dm = (candles[i].high + candles[i].low) / 2 - (candles[i - 1].high + candles[i - 1].low) / 2;
      const hl = candles[i].high - candles[i].low;
      const br = hl === 0 ? 0 : (candles[i].volume || 1) / hl;
      raw.push(br === 0 ? 0 : dm / br);
    }

    const sma = computeSMA(raw, period);
    for (let i = 0; i < sma.length; i++) {
      if (!isNaN(sma[i])) {
        data.push({ time: candles[i].time, value: sma[i] });
      }
    }

    return [{ key: "emv", data }];
  },
};
